import { render, staticRenderFns } from "./media-batch-sync.vue?vue&type=template&id=227495d6&scoped=true"
import script from "./media-batch-sync.vue?vue&type=script&lang=js"
export * from "./media-batch-sync.vue?vue&type=script&lang=js"
import style0 from "./media-batch-sync.vue?vue&type=style&index=0&id=227495d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227495d6",
  null
  
)

export default component.exports